<template>
  <section class="album-digital-section" ref="albumRef">
    <div class="album-container">
      
      <!-- COLUMNA IZQUIERDA: COPY PERSUASIVO ALL-INCLUSIVE -->
      <div class="album-info" ref="infoRef">
        <span class="exclusivo-tag">✦ INCLUIDO EN TU PAQUETE PREMIUM ✦</span>
        <h2 class="album-titulo">
          Captura cada instante <br />
          <span>Sin costos extras ni sorpresas</span>
        </h2>
        <p class="album-descripcion">
          Olvídate de contratar plataformas extras o servicios por separado. Tu <strong>Invitación Premium ya incluye de forma integral</strong> el sistema de <strong>Álbum Digital Privado</strong> y el <strong>Libro de Firmas</strong> dentro del mismo costo. Tus invitados viven la experiencia desde su celular y tú recibes todo al instante. 
        </p>

        <!-- CARACTERÍSTICAS DE VALOR -->
        <div class="beneficios-album">
          <div class="beneficio-item">
            <div class="beneficio-icono">✨</div>
            <div class="beneficio-texto">
              <h4>Todo Incluido (All-Inclusive)</h4>
              <p>Al adquirir el Paquete Premium, estos módulos ya se encuentran activos y listos para usar. Tus invitados suben fotos y firman dedicatorias sin descargar ninguna app.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- COLUMNA DERECHA: EXPERIENCIA VIVA INTERACTIVA (EL SIMULADOR REAL) -->
      <div class="album-visual" ref="visualRef">
        
        <!-- INTERFAZ INTERACTIVA REAL -->
        <div class="modulo-experiencia-viva">
          <div class="interfaz-header">
            <div class="luces-interfaz">
              <span class="luz red"></span>
              <span class="luz yellow"></span>
              <span class="luz green"></span>
            </div>
            <span class="interfaz-titulo">Módulos Premium Incluidos</span>
          </div>

          <!-- PESTAÑAS EXPLICATIVAS DE LO QUE YA INCLUYE -->
          <div class="interfaz-tabs">
            <button 
              :class="{ activo: tabActiva === 'fotos' }" 
              @click="tabActiva = 'fotos'"
            >
              📸 Álbum Digital (Incluido)
            </button>
            <button 
              :class="{ activo: tabActiva === 'firmas' }" 
              @click="tabActiva = 'firmas'"
            >
              ✍ Libro de Firmas (Incluido)
            </button>
          </div>

          <div class="interfaz-cuerpo">
            
            <!-- PESTAÑA 1: EXPERIENCIA SUBIR FOTOS -->
            <div v-if="tabActiva === 'fotos'" class="tab-contenido-dinamico">
              <div v-if="!fotoSubida && !cargandoFoto" class="zona-drop" @click="dispararInputFile">
                <div class="icono-subida">✨</div>
                <p class="instruccion-subida">Haz clic aquí para probar la experiencia que vivirán tus invitados</p>
                <span class="btn-subida-simulada">Probar Subir Foto</span>
                <input 
                  type="file" 
                  ref="inputFileRef" 
                  style="display: none" 
                  accept="image/*" 
                  @change="procesarFotoMuestra"
                />
              </div>

              <!-- Animación de Carga Efecto Neuro-ventas -->
              <div v-if="cargandoFoto" class="pantalla-carga">
                <div class="spinner-premium"></div>
                <p>Guardando de forma segura en el álbum de la festejada...</p>
              </div>

              <!-- Pantalla de ÉXITO Real instantáneo -->
              <div v-if="fotoSubida && !cargandoFoto" class="pantalla-exito-real">
                <div class="circulo-check-exito">✓</div>
                <h4>¡Compartido con Éxito!</h4>
                <p>Esta foto se guarda en tu panel privado automáticamente.</p>
                <div class="preview-foto-contenedor">
                  <img :src="fotoPreviewUrl" class="foto-preview-render" />
                </div>
                <button class="btn-reiniciar-experiencia" @click="reiniciarFotos">Subir Otra Foto</button>
              </div>
            </div>

            <!-- PESTAÑA 2: EXPERIENCIA ÁLBUM DE FIRMAS -->
            <div v-if="tabActiva === 'firmas'" class="tab-contenido-dinamico">
              <div class="formulario-firmas-vivo">
                <label>Tu Nombre o Familia:</label>
                <input 
                  v-model="inputFirmaAutor" 
                  type="text" 
                  placeholder="Ej. Familia Cavazos Zapata" 
                  maxLength="40"
                />
                
                <label>Tu Dedicatoria de Felicitación:</label>
                <textarea 
                  v-model="inputFirmaTexto" 
                  placeholder="Escribe tus deseos aquí! Mira cómo se publica en tiempo real abajo..."
                  maxLength="160"
                ></textarea>
              </div>

              <!-- El libro donde se pintan las firmas al instante -->
              <div class="libro-firmas-renderizado">
                <span class="tag-libro-firmas">✦ Módulo de Firmas Integrado ✦</span>
                <p class="comentario-render">
                  "{{ inputFirmaTexto || '¡Te ves hermosa, que seas inmensamente feliz en esta nueva etapa! Gracias por hacernos parte...' }}"
                </p>
                <span class="autor-render">
                  — {{ inputFirmaAutor || 'Tu Invitado Especial' }}
                </span>
              </div>
            </div>

          </div>
          
          <!-- Banner de validación al pie del simulador -->
          <div class="interfaz-footer-banner">
            ✓ Todo esto forma parte de tu experiencia Premium por el mismo costo
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'AlbumDigitalSection',
  setup() {
    const albumRef = ref(null)
    const infoRef = ref(null)
    const visualRef = ref(null)
    
    // Estados interactivos instantáneos
    const tabActiva = ref('fotos') 
    const inputFileRef = ref(null)
    const cargandoFoto = ref(false)
    const fotoSubida = ref(false)
    const fotoPreviewUrl = ref('')

    // Estados firmas en vivo
    const inputFirmaAutor = ref('')
    const inputFirmaTexto = ref('')

    onMounted(async () => {
      await nextTick()

      // Animaciones GSAP de entrada elegante
      gsap.from(infoRef.value.children, {
        opacity: 0,
        y: 35,
        duration: 0.9,
        stagger: 0.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: albumRef.value,
          start: 'top 75%',
          once: true
        }
      })

      gsap.from('.modulo-experiencia-viva', {
        opacity: 0,
        scale: 0.95,
        y: 40,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: albumRef.value,
          start: 'top 75%',
          once: true
        }
      })
    })

    const dispararInputFile = () => {
      inputFileRef.value.click()
    }

    const procesarFotoMuestra = (event) => {
      const archivo = event.target.files[0]
      if (archivo) {
        cargandoFoto.value = true
        fotoPreviewUrl.value = URL.createObjectURL(archivo)
        
        // Simular carga corta
        setTimeout(() => {
          cargandoFoto.value = false
          fotoSubida.value = true
        }, 1500)
      }
    }

    const reiniciarFotos = () => {
      fotoSubida.value = false
      fotoPreviewUrl.value = ''
    }

    return {
      albumRef,
      infoRef,
      visualRef,
      tabActiva,
      inputFileRef,
      cargandoFoto,
      fotoSubida,
      fotoPreviewUrl,
      inputFirmaAutor,
      inputFirmaTexto,
      dispararInputFile,
      procesarFotoMuestra,
      reiniciarFotos
    }
  }
}
</script>

<style scoped>
/* ==========================================================================
   PALETA DE COLORES LUXURY: CHAMPAGNE, IVORY Y ORO ROSA
   ========================================================================== */
.album-digital-section {
  background: #fffefc; 
  padding: 120px 4% 110px;
  overflow: hidden;
  position: relative;
}

.album-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  max-width: 1150px;
  margin: 0 auto;
  align-items: center;
}

/* COLUMNA IZQUIERDA: CONTENIDO ALL-INCLUSIVE */
.album-info {
  text-align: left;
}

.exclusivo-tag {
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #e293a0; 
  margin-bottom: 15px;
  font-weight: 700;
}

.album-titulo {
  font-size: 3.2rem;
  color: #2b2927; 
  line-height: 1.15;
  margin: 0 0 25px 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
}

.album-titulo span {
  font-family: 'ludovica', serif;
  font-style: italic;
  font-weight: 400;
  background: linear-gradient(45deg, #e293a0, #bfa18f, #d4a373);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.album-descripcion {
  color: #6a6561;
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 35px;
}

.album-descripcion strong {
  color: #e293a0;
  font-weight: 600;
}

.beneficios-album {
  display: flex;
  flex-direction: column;
}

.beneficio-item {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.beneficio-icono {
  background: #fff3f5;
  border: 1px solid rgba(226, 147, 160, 0.25);
  width: 50px;
  height: 50px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  flex-shrink: 0;
  box-shadow: 0 8px 20px rgba(226, 147, 160, 0.1);
}

.beneficio-texto h4 {
  font-family: 'Montserrat', sans-serif;
  color: #2b2927;
  font-size: 1.1rem;
  margin: 0 0 6px 0;
  font-weight: 600;
}

.beneficio-texto p {
  font-family: 'Montserrat', sans-serif;
  color: #7a736e;
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
}

/* ==========================================================================
   COLUMNA DERECHA: SIMULADOR DE MÓDULOS INTEGRADOS
   ========================================================================== */
.album-visual {
  width: 100%;
}

.modulo-experiencia-viva {
  background: #ffffff;
  border: 1px solid rgba(212, 163, 115, 0.2);
  border-radius: 28px;
  box-shadow: 0 25px 55px rgba(186, 171, 157, 0.25);
  overflow: hidden;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}

.interfaz-header {
  background: #faf7f4;
  border-bottom: 1px solid rgba(0,0,0,0.04);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.luces-interfaz {
  display: flex;
  gap: 6px;
}

.luz {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.luz.red { background: #ff5f56; }
.luz.yellow { background: #ffbd2e; }
.luz.green { background: #27c93f; }

.interfaz-titulo {
  font-family: 'Montserrat', sans-serif;
  color: #9e968f;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

/* TABS NAVEGACIÓN CON TEXTO DE INCLUSIÓN */
.interfaz-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #fdfaf7;
  border-bottom: 1px solid rgba(212, 163, 115, 0.1);
}

.interfaz-tabs button {
  background: transparent;
  border: none;
  padding: 15px 10px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #8c827a;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.interfaz-tabs button.activo {
  background: #ffffff;
  color: #e293a0;
  box-shadow: inset 0 -2px 0 #e293a0;
}

.interfaz-cuerpo {
  padding: 25px;
  min-height: 330px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffff;
}

.tab-contenido-dinamico {
  width: 100%;
  height: 100%;
}

/* SUBIDA DE FOTOS */
.zona-drop {
  border: 2px dashed rgba(226, 147, 160, 0.3);
  background: #fffdfd;
  border-radius: 18px;
  padding: 35px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.zona-drop:hover {
  border-color: #e293a0;
  background: #fff3f5;
}

.icono-subida {
  font-size: 2.2rem;
  margin-bottom: 12px;
}

.instruccion-subida {
  font-family: 'Montserrat', sans-serif;
  color: #5c5550;
  font-size: 0.92rem;
  line-height: 1.4;
  margin: 0 0 18px 0;
}

.btn-subida-simulada {
  display: inline-block;
  background: linear-gradient(45deg, #e293a0, #cc818e);
  color: white;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  padding: 12px 24px;
  border-radius: 30px;
  box-shadow: 0 5px 15px rgba(226, 147, 160, 0.3);
}

/* CARGANDO */
.pantalla-carga {
  text-align: center;
  padding: 20px;
}

.spinner-premium {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(226, 147, 160, 0.1);
  border-top-color: #e293a0;
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: spin 1s infinite linear;
}

.pantalla-carga p {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  color: #7a736e;
}

/* EXITO EN SUBIDA */
.pantalla-exito-real {
  text-align: center;
}

.circulo-check-exito {
  background: #27c93f;
  color: white;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  margin: 0 auto 12px;
  box-shadow: 0 5px 15px rgba(39, 201, 63, 0.3);
}

.pantalla-exito-real h4 {
  font-family: 'Montserrat', sans-serif;
  color: #2b2927;
  font-size: 1.15rem;
  margin: 0 0 6px 0;
}

.pantalla-exito-real p {
  font-family: 'Montserrat', sans-serif;
  color: #7a736e;
  font-size: 0.85rem;
  margin: 0 0 15px 0;
}

.preview-foto-contenedor {
  width: 90px;
  height: 90px;
  margin: 0 auto 15px;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid white;
  box-shadow: 0 5px 15px rgba(0,0,0,0.15);
}

.foto-preview-render {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.btn-reiniciar-experiencia {
  background: transparent;
  border: 1px solid rgba(226, 147, 160, 0.4);
  color: #e293a0;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-reiniciar-experiencia:hover {
  background: #fff3f5;
}

/* FORMULARIO DE FIRMAS */
.formulario-firmas-vivo {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 20px;
}

.formulario-firmas-vivo label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #8c827a;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.formulario-firmas-vivo input,
.formulario-firmas-vivo textarea {
  border: 1px solid rgba(212, 163, 115, 0.25);
  background: #faf7f4;
  border-radius: 10px;
  padding: 10px 12px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  color: #4a443f;
  margin-bottom: 12px;
  outline: none;
  transition: border-color 0.3s ease;
}

.formulario-firmas-vivo input:focus,
.formulario-firmas-vivo textarea:focus {
  border-color: #e293a0;
  background: #ffffff;
}

.formulario-firmas-vivo textarea {
  height: 60px;
  resize: none;
}

/* BOOK RENDER */
.libro-firmas-renderizado {
  background: #fffdfc;
  border: 1px dashed rgba(212, 163, 115, 0.4);
  padding: 16px;
  border-radius: 14px;
  text-align: left;
}

.tag-libro-firmas {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.68rem;
  letter-spacing: 1px;
  color: #cc818e;
  font-weight: 700;
  display: block;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.comentario-render {
  font-family: 'Montserrat', sans-serif;
  color: #5c5550;
  font-size: 0.82rem;
  line-height: 1.4;
  font-style: italic;
  margin: 0 0 6px 0;
}

.autor-render {
  font-family: 'ludovica', serif;
  color: #bfa18f;
  font-size: 1rem;
  display: block;
  text-align: right;
}

/* BANNER FIJO DEL SIMULADOR */
.interfaz-footer-banner {
  background: rgba(226, 147, 160, 0.08);
  border-top: 1px solid rgba(226, 147, 160, 0.15);
  padding: 12px 15px;
  font-family: 'Montserrat', sans-serif;
  color: #cc818e;
  font-size: 0.78rem;
  font-weight: 600;
  text-align: center;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* RESPONSIVO */
@media (max-width: 992px) {
  .album-container {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  .album-info {
    text-align: center;
  }
  .album-titulo {
    font-size: 2.8rem;
  }
}

@media (max-width: 576px) {
  .album-digital-section {
    padding: 80px 20px 60px;
  }
  .album-titulo {
    font-size: 2.2rem;
  }
}
</style>